import React        from 'react';
import PropTypes    from 'prop-types';
import Translations from "../../utils/Translations";
import Flux         from "../../flux/Flux";
import { generateKey } from '../../utils/CommonUtils';

class SearchResultsHeader extends React.PureComponent {

	constructor(props) {
		super(props);

		this.onSelectTab = this.onSelectTab.bind(this);
	}

	parseCount(count) {
		if (count > 9999) {
			count = '9999+';
		}

		return count;
	}

	onSelectTab(e, id) {
		e.preventDefault();
		e.stopPropagation();

		if (id === this.props.activeCategory) {
			return;
		}

		this.props.onCategoryChange(id);
	}

	getTab(name, count, category, idx) {
		return (
			<button key={generateKey(name, idx)}
				  onClick={e => (this.onSelectTab(e, category))}
			      className={"searchresults_header-tab" + (category === this.props.activeCategory ? ' -is-active' : '')}
			>
				<span className="searchresults_header-tab-name">{name}</span>
				<span className="searchresults_header-tab-count">{this.parseCount(count)}</span>
			</button>
		);
	}

	render() {
		const tabs = [];

		if (this.props.actorResultCount > 0 || this.props.activeCategory === Flux.Constants.SearchResults.Categories.actors.name) {
			tabs.push(this.getTab(Translations.get('CollectionSearchResultsActors'), this.props.actorResultCount, Flux.Constants.SearchResults.Categories.actors.name, tabs.length));
		}
		if (this.props.videoResultCount > 0 || this.props.activeCategory === Flux.Constants.SearchResults.Categories.videos.name) {
			tabs.push(this.getTab('Videos', this.props.videoResultCount, Flux.Constants.SearchResults.Categories.videos.name, tabs.length));
		}
		if (!Flux.Browser.isSexole() && (this.props.tvResultCount > 0 || this.props.activeCategory === Flux.Constants.SearchResults.Categories.tv.name)) {
			tabs.push(this.getTab('TV', this.props.tvResultCount, Flux.Constants.SearchResults.Categories.tv.name, tabs.length));
		}
		if (!Flux.Browser.isSexole() && (this.props.blogResultCount > 0 || this.props.activeCategory === Flux.Constants.SearchResults.Categories.blog.name)) {
			tabs.push(this.getTab('Blog', this.props.blogResultCount, Flux.Constants.SearchResults.Categories.blog.name, tabs.length));
		}

		return <div className="searchresults_header">{tabs}</div>;
	}

}


SearchResultsHeader.propTypes = {
	activeCategory:   PropTypes.string,
	actorResultCount: PropTypes.number,
	videoResultCount: PropTypes.number,
	tvResultCount:    PropTypes.number,
	blogResultCount:  PropTypes.number,
	onCategoryChange: PropTypes.func.isRequired,
};

SearchResultsHeader.defaultProps = {
	activeCategory:   Flux.Constants.SearchResults.Categories.actors,
	actorResultCount: 0,
	videoResultCount: 0,
	tvResultCount:    0,
	blogResultCount:  0,
};

export default SearchResultsHeader;
